import spacetime from 'spacetime';

export function formatMenuDate( date: string ) {
  if ( date === spacetime.today().format('iso-short') ) { 
    return 'Today' 
  } else if ( date === spacetime.tomorrow().format('iso-short') ) { 
    return 'Tomorrow' 
  } else { 
    return spacetime(date).format('{day-short}, {month-short} {date}'); 
  }
}

export function formatOrderDate( date: string ) {
  return spacetime(date).format('{month-short} {date-ordinal}, {year}');
}

export function formatDuration( duration: number ) {
  const hours = Math.floor(duration / 60);          
  const minutes = duration % 60;
  const hoursLabel = hours === 1 ? 'hour' : 'hours';
  const hoursOutput = hours ? `${hours} ${hoursLabel}` : '';
  const minutesOutput = minutes ? `${minutes} minutes` : '';
  let output = hoursOutput + ' ' + minutesOutput;  
  return output.trim();
}

export function formatAmount(amount) {
  return Number(amount/100).toFixed(2);
}

export function fixedPrice(price): string {
  return Number(price).toFixed(2);
}

export function inputOut(event) {
  if (event.target.value) {
    event.target.classList.add('has-value');
  } else if (!event.target.value && event.target.classList.contains('has-value')) {
    event.target.classList.remove('has-value');
  }
}
